
import React from "react";
import { Box } from "grommet";

const BodyWrapper = ({children}) => {
  return <Box fill={true} align={"center"} justify={"center"} grow={"true"}>{children}</Box>
}

export default BodyWrapper;